import {
  InnerContentItem,
  SectionMessage,
  SummaryCard,
} from "@certn/cascadia-react";
import { ArrayControlProps } from "@jsonforms/core";
import { useTranslation } from "react-i18next";

import { useApplicationFormContext } from "../../ApplicationFormContext";
import { useApplication } from "../../ApplicationContext";
import { SummaryEditLink } from "../../layouts/SummaryEditLink";
import { useKonfirVerification } from "./hooks/useKonfirVerification";
import { NotStarted } from "../../layouts/NotStarted";

export const EmploymentVerificationSummaryControl = (
  _props: ArrayControlProps
) => {
  const { t } = useTranslation();
  const { caseId } = useApplicationFormContext();
  const { basePath = "apply", completedSections } = useApplication();
  const { status } = useKonfirVerification(caseId);

  const sectionPath = `/${basePath}/${caseId}/employment-verification`;
  const isUncompleted = !completedSections?.includes("employment-verification");

  return (
    <SummaryCard
      header={t("Employment Verification")}
      actions={
        isUncompleted ? undefined : (
          <SummaryEditLink
            href={sectionPath}
            testID="employment-verification-summary-edit"
          />
        )
      }
      testID="employment-verification-summary"
    >
      {isUncompleted ? (
        <NotStarted sectionKey="employment-verification" showErrors={false} />
      ) : status === "BYPASSED" ? (
        <SectionMessage
          sectionTitle={t("Employment verification skipped")}
          type="warning"
          icon="warning"
        />
      ) : (
        <InnerContentItem label={t("Connected account")}>
          {status === "COMPLETED" || status === "IN_PROGRESS"
            ? t("Yes")
            : t("No")}
        </InnerContentItem>
      )}
    </SummaryCard>
  );
};
